import type { EventMarketType, EventType } from "app/types/eventType";
import PlayerPropRunner from "../PlayerPropRunner/PlayerPropRunner";

type Props = {
  event: EventType;
  market: EventMarketType;
  marketType: Record<string, any>;
  runner: Record<string, any>;
  groupedBy: string;
};

const RenderPlayerProps = ({ event, market, marketType, groupedBy }: Props) => {
  return (
    <>
      <PlayerPropRunner
        runner={market.runners}
        index={market.id}
        event={event}
        market={market}
        key={`runner-${market.type}`}
        groupedBy={"type"}
        marketType={marketType}
      />
    </>
  );
};

export default RenderPlayerProps;
